import { useLanguage } from "../context/languageContext";

export const LanguageSelector = ({ onSelectLanguage }) => {
  const { languages, languageLabels, selectedLang } = useLanguage();

  const selectedLanguageLabel = selectedLang 
    ? (languageLabels[selectedLang] || selectedLang.toUpperCase())
    : "Select Language";

  return (
    <div className="d-flex gap-2 align-items-center px-3">
      <div className="dropdown">
        <button
          className="btn btn-dark dropdown-toggle"
          type="button"
          id="dropdownMenu2"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {selectedLanguageLabel}
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenu2">
          {languages.map((lang) => (
            <li key={lang}>
              <button
                className="dropdown-item"
                type="button"
                onClick={() => onSelectLanguage(lang)}
              >
                {languageLabels[lang] || lang.toUpperCase()}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LanguageSelector;
